import {
  FieldBuilder,
  FieldDefinition,
  MenuCategories,
  MenuSubcategories,
  MENU_CATEGORY_KEY,
  MENU_NAME_SUFFIX,
  MENU_SUBCATEGORY_KEY,
  LocationTypes,
} from '@zendra/shared';
import { LocationService, PropertyService } from 'cbd-proxies';
import { WoodCertificationService } from '../../proxy/geographic/controllers';

FieldBuilder.setNamespace('Geographic');

export const CERTIFIEDREGISTERS_FIELDS: FieldDefinition[] = [
  FieldBuilder.foreignKey('woodCertificationId', 'Entity.WoodCertification', WoodCertificationService)
    .required()
    .display('name')
    .displayFromNested('woodCertificationName')
    .sortBy('woodCertificationName')
    .hideInChildForms()
    .build(),
  FieldBuilder.foreignKey('locationId', 'Entity.Register', LocationService)
    .display('name')
    .displayFromNested('locationName')
    .sortBy('locationName')
    .queryFilter({ locationTypeEntityName: LocationTypes.Register })
    .required()
    .build(),
  FieldBuilder.foreignKey('propertyId', 'Entity.Property', PropertyService)
    .display('name')
    .displayFromNested('propertyName')
    .sortBy('propertyName')
    .readOnly()
    .build(),
  FieldBuilder
    .date('addedDate', 'Entity.WoodCertificationDetail.AddedDate')
    .required()
    .build()
];

export const CERTIFIEDREGISTERS_CONFIG = {
  entityName: 'CertifiedRegisters',
  localizationKey: 'Geographic::WoodCertificationDetail.CertifiedRegisters',
  fields: CERTIFIEDREGISTERS_FIELDS,
  permission: 'PlanningGeography.WoodCertificationDetails',
  showInMenu: false,
  menuCategory: '',
  menuSubcategory: '',
};
